import { NgModule, Optional, SkipSelf } from '@angular/core';

import { CommonModule } from '@angular/common';
import { NotifierComponent } from './notifier.component';
import { NotifierService } from './notifier.service';
import { TranslateModule } from '@ngx-translate/core';
import { throwIfAlreadyLoaded } from '../module-import-guard';

@NgModule({
  imports: [ CommonModule, TranslateModule ],
  exports: [ NotifierComponent ],
  declarations: [ NotifierComponent ],
  providers: [ NotifierService ]
})
export class NotifierModule {

  constructor(@Optional() @SkipSelf() parentModule: NotifierModule) {
    throwIfAlreadyLoaded(parentModule, 'NotifierModule');
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/notifier/notifier.module.ts